import { Path, Group } from "@progress/kendo-drawing";
type ScatterItem = {
  category?: string;
  color?: string;
  xField: any;
  yField: any;
};
export const useScatterDrawingLogic = (
  portfolioItem: ScatterItem | undefined
) => {
  const drawLines = (ev: any) => {
    const chart = ev.target.chartInstance;
    if (!chart || !portfolioItem) {
      return;
    }

    // get the axes
    const xAxis = chart.findAxisByName("xAxis");
    const yAxis = chart.findAxisByName("yAxis");

    if (!xAxis || !yAxis) {
      return;
    }

    const zeroOnXAxis = xAxis.slot(0);
    const zeroOnYAxis = yAxis.slot(0);
    const portfolioX = xAxis.slot(portfolioItem.xField);
    const portfolioY = yAxis.slot(portfolioItem.yField);

    // Calculate the direction vector (note the inverted y direction)
    const dirX = portfolioX.origin.x - zeroOnXAxis.origin.x;
    const dirY = zeroOnYAxis.origin.y - portfolioY.origin.y;

    // Calculate the slope and y-intercept of the line
    const slope = dirY / dirX;
    const yIntercept = zeroOnYAxis.origin.y;

    // Get chart dimensions
    const chartWidth = chart.element.clientWidth;
    const chartHeight = chart.element.clientHeight;

    // Function to calculate y for a given x (note the inversion)
    const getY = (x: number) => yIntercept - slope * (x - zeroOnXAxis.origin.x);

    // Find the intersection with the chart boundaries
    let endX, endY;

    // Check right boundary
    const rightY = getY(chartWidth);
    if (rightY >= 0 && rightY <= chartHeight) {
      endX = chartWidth;
      endY = rightY;
    } else if (rightY < 0) {
      // Intersects top boundary
      endX = yIntercept / slope + zeroOnXAxis.origin.x;
      endY = 0;
    } else {
      // Intersects bottom boundary
      endX = (chartHeight - yIntercept) / slope + zeroOnXAxis.origin.x;
      endY = chartHeight;
    }

    const greenLine = new Path({
      stroke: {
        color: "purple",
        width: 1,
      },
    })
      .moveTo(zeroOnXAxis.origin.x, zeroOnYAxis.origin.y)
      .lineTo(endX, endY);

    const group = new Group();
    group.append(greenLine);
    group.opacity(0.3);

    chart.surface.draw(group);
  };

  return { drawLines };
};
